import React from 'react';
import CloroxProductGroups from 'components/Tvendo/Sale/QuotaBPartner/Clorox/ProductGroupsClorox/List.js';

export default function () {
  return <CloroxProductGroups />;
}
